<template>
    <span>
        <a v-if="userPermissions && userPermissions.can_edit_reservation"
            :style="!reservation.user.status && 'padding-left: 33px'"
            :href="`/app/guest/${reservation.user.id}/invoices/?reservation=${reservation.id}`">
            <span v-html="reservation.user.status
                ? renderGuestStatusIcon(reservation.user.status)
                : ''
                ">
            </span>{{ guestName }}
        </a>
        <span v-else :style="!reservation.user.status && 'padding-left: 33px'">
            <span v-html="reservation.user.status
                ? renderGuestStatusIcon(reservation.user.status)
                : ''
                ">
            </span>{{ guestName }}
        </span>
    </span>
</template>

<script>
import { renderGuestStatusIcon } from '../helpers';
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            reservation: {
                id: null,
                user: {
                    id: null,
                    status: null,
                    short_name: null,
                },
                guest_name: null,
                owner_name: null,
                is_blocked: false
            },
        };
    },
    mounted() {
        this.reservation = this.params.getReservation(this.params);
    },
    computed: {
        ...mapGetters('header', ['userPermissions']),
        guestName() {
            if (this.reservation.is_blocked && this.reservation.owner_name) {
                return `Owner - ` + this.reservation.owner_name
            }
            return (
                this.reservation.guest_name || this.reservation.user.short_name
            );
        },
    },
    methods: {
        renderGuestStatusIcon: renderGuestStatusIcon,
    },
};
</script>

<style>
.dashboard-guest-status-icon {
    width: 24px;
    height: 23px;
    margin-right: 0.5rem;
}
</style>

